import { render, staticRenderFns } from "./Pregledi.vue?vue&type=template&id=1c598422&scoped=true"
import script from "./Pregledi.vue?vue&type=script&lang=js"
export * from "./Pregledi.vue?vue&type=script&lang=js"
import style0 from "./Pregledi.vue?vue&type=style&index=0&id=1c598422&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c598422",
  null
  
)

export default component.exports